import React, { useContext, useEffect } from "react";
import { DataTable } from "@/components/DataTable";
// import { Button } from "@/components/ui";
import { useTranslation } from "react-i18next";
import { User } from "@/__generated__/graphql";
import { Row } from "@tanstack/react-table";
// import { useNavigate } from "react-router-dom";
import { RemoveButton } from "@/components/RemoveButton";
import { TeamTableContext } from "./TeamTable";
import { REMOVE_OFFICIAL_FROM_ORGANIZATION_MUTATION } from "@/api/mutations/removeOfficialFromOrganization";
import { useMutation } from "@apollo/client";
import { toast } from "sonner";

export const TeamTableActions = ({
  row,
  orgId,
}: {
  row: Row<User | null>;
  orgId?: string;
}) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const { id } = row.original || {};
  const { refetch } = useContext(TeamTableContext);

  const [removeOfficial, { data }] = useMutation(
    REMOVE_OFFICIAL_FROM_ORGANIZATION_MUTATION,
  );

  useEffect(() => {
    if (data?.removeOfficialFromOrganizationMutation?.errors?.length) {
      const { errors } = data?.removeOfficialFromOrganizationMutation ?? {};
      toast.error(t("teamManagement.table.remove.error"), {
        description: errors?.map(({ message }) => message).join(", "),
      });
    } else if (data?.removeOfficialFromOrganizationMutation) {
      toast.success(t("teamManagement.table.remove.success"));
      if (refetch) {
        refetch();
      }
    }
  }, [data, refetch, t]);

  return (
    <DataTable.TBodyCell>
      <div className="flex items-center justify-end gap-2">
        {/* TODO: This navigate path ("edit") should have a constant in paths.ts */}
        {/* Remove "edit" until the flow is ready
        <Button
          type="button"
          variant="outline"
          onClick={() => navigate(`${id}/edit`)}
        >
          {t("teamManagement.table.edit")}
        </Button>
  */}
        <RemoveButton
          alertTitle={t("teamManagement.table.remove.title")}
          alertDescription={t("teamManagement.table.remove.description")}
          deleteAction={() =>
            id &&
            orgId &&
            removeOfficial({
              variables: { userId: id, organizationId: orgId },
            })
          }
        />
      </div>
    </DataTable.TBodyCell>
  );
};
